import { formatDateTime } from './site-time';

/** Roundtrip wall-clock values in the saved site timezone, independent of the browser timezone. */
export function localLifecycleTime(instant: string | Date, timezone: string): string {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: timezone, year: 'numeric',
    month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
    hourCycle: 'h23' }).formatToParts(new Date(instant));
  const get = (key: Intl.DateTimeFormatPartTypes) => parts.find(p => p.type === key)!.value;
  return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}:${get('second')}`;
}

export function formatLifecycleTime(instant: string, timezone: string): string {
  return formatDateTime(instant, { kind: 'site', timeZone: timezone }, { includeZone: true });
}

/** Zero matches means a DST gap; two means the administrator must choose the intended occurrence. */
export function lifecycleTimeChoices(local: string, timezone: string): string[] {
  const wall = local.length === 16 ? local + ':00' : local;
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(wall)) return [];
  const nominal = Date.parse(wall + 'Z');
  if (!Number.isFinite(nominal)) return [];
  const matches = new Set<string>();
  // IANA offsets in the supported modern scheduling range are minute-aligned.
  for (let offset = -14 * 60; offset <= 14 * 60; offset++) {
    const at = new Date(nominal - offset * 60_000);
    if (localLifecycleTime(at, timezone) === wall) matches.add(at.toISOString());
  }
  return [...matches].sort();
}
